import { Entity } from 'siren-parser';

export interface OrganizationTypeEntity extends Entity {
  properties: {
    name: OrganizationType,
  }
}
enum OrganizationTypeEnum {
  'account-group',
  'account',
  'barn',
  'billing-account',
  'binsentry',
  'customer',
  'department',
  'farm',
  'mill-bins-group',
  'sales-account',
  'service-account',
  'service-partner',
}

export type OrganizationType = keyof typeof OrganizationTypeEnum;
export const ALL_ORGANIZATION_TYPES = Object.values(OrganizationTypeEnum) as OrganizationType[];
